import axiosPublicInstance from "module/common/utils/axiosConfig";
var withApiKey = function (apiKey) {
    axiosPublicInstance.defaults.headers.common["API-Key"] = apiKey;
};
export var putProperties = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/beta6/properties", payload);
};
export var putAPNProperties = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/beta6/apn_properties", payload);
};
export var putPropertyDetails = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/beta6/property_details", payload);
};
export var putPerson = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/beta6/person", payload);
};
export var putWorkplace = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/beta6/workplace", payload);
};
export var putReversePhone = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/beta6/reverse_phone", payload);
};
export var putCriminal = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/beta6/criminal", payload);
};
export var putBusiness = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/beta6/business", payload);
};
export var putDNCStatus = function (payload, apiKey) {
    withApiKey(apiKey);
    return axiosPublicInstance.put("/api/dnc/status", payload);
};
